import React from 'react';
import OfficialTableRow from './OfficialTableRow';
import { ProductTypes } from 'types/shared';

interface IOfficialChartRowsProps {
  charts: any[] | undefined;
  isSmallScreen: boolean;
  productType: ProductTypes;
  showProductColumn: boolean;
}

const OfficialChartRows: React.FC<IOfficialChartRowsProps> = (props) => {
  const { charts, isSmallScreen, productType, showProductColumn } = props;

  if (!charts?.length) {
    return null;
  }

  return (
    <>
      {charts.map((chart, index) => {
        const key = `LCR-${chart.chartId}-${index}`;
        return (
          <OfficialTableRow
            key={key}
            chart={chart}
            isSmallScreen={isSmallScreen}
            productType={productType}
            showProductColumn={showProductColumn}
          />
        );
      })}
    </>
  );
};

export default OfficialChartRows;
